import { CommonUtilities } from "../../commonUtils";
import Pagination from "../Header/Pagination";
import React, { Suspense, useState, useEffect } from "react";
import AddUserServices from "./UserServices";

export default function UserListing (projectDetails : any){

    const [userslist, initUserslist] = useState<any[]>([]);
    const [totalRows ,setTotalRows] = useState(1);
    var dataLink = "pageSize=10&pageNumber=1"; 
   
    const Data:any =  {
        pageSize : 10,
        pageNumber : 1 ,
        ProjectId: projectDetails.projectDetails.ProjectId,
    }
    
    useEffect(() => {
        getUser()       
    }, [totalRows]);

    const handleNameOnChange = (n: any) => {  
        Data.pageNumber = n.pageNumber;
        Data.pageSize =n.pageSize;  
        getUser()
    }

    let [users_list, initUsers_list] = useState<any[]>([]);

    const getUser= () => {
        Data.ProjectId =projectDetails.projectDetails.ProjectId ;
        dataLink = 'projectId='+projectDetails.projectDetails.ProjectId+ '&pageSize=' + Data.pageSize +'&pageNumber=' + Data.pageNumber;        

        AddUserServices.UserListing(dataLink)
        .then((res) => {          
  
            if (res === null){
                projectDetails.onChange(0)
                setTotalRows(0);
            }

            if(res.length === 0 ){
                projectDetails.onChange(0)
                setTotalRows(0);
            }else{
                initUsers_list(res.contacts)
                setTotalRows(res.totalRows)
                //projectDetails.onChange(totalRows)
            }
            console.log(users_list)         

        })
    }

    return (
        <>
            <div className="box-content p0">
            <Suspense fallback={<div>Loading</div>}>
                    
                {(() => {
                        if(totalRows>1 ){
                             return (users_list.map((post, index) =>             
                                    <div className="ws-5 mt pm" >
                                            <div className="box shadow pm">
                                                <div className="ws-2">
                                                   <div className="circularLogo text-center pull-left"> <img src={post.kontactImage  }/></div>
                                                </div>
            
                                                <div className="ws-10">
                                                    <div className="ws-12 text-bold mts">{post.contactName}
                                                        <a className="pull-right"><i className="icon-menu text-l"></i></a>
                                                    </div>            
                                                    <div className="ws-12 mt">{post.contactTypeDesc} | {post.addEmail}</div>
                                                </div>
                                            </div>
                                    </div>                                        )
                                )
                             }else{
                                return (<div className="ptl">
                                    <span className="alert alert-success ws-12 text-center">No data Available</span>
                                </div>)
                         }
                                            
                    })()
                }                    
              
            </Suspense>           
            </div>
            {     
               (() => {
                   if(totalRows>1 && totalRows>10){
                      return <Pagination onChange={handleNameOnChange} totalRows={totalRows} />
                   }
                   
               })()
           } 
        </>
    )
}